import React from 'react';

import NoMatch from '../NoMatch';

export const OrderNotFound = ({ hide, text, title }) => {
  if (hide) {
    return null;
  }

  return <NoMatch text={text} title={title} hideBackground />;
};

OrderNotFound.defaultProps = {
  title: `Order Not Found`,
  text: `We were unable to retrieve the order. The order could have been deleted or you may not have the appropriate permissions to view the order`
};

export default OrderNotFound;
